import { render } from "./Details.vue?vue&type=template&id=a47855a8&scoped=true"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"

import "./Details.vue?vue&type=style&index=0&id=a47855a8&scoped=true&lang=css"
import "./Details.vue?vue&type=style&index=1&id=a47855a8&lang=css"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a47855a8"]])

export default __exports__